// extracted by mini-css-extract-plugin
module.exports = {"view":"styles_view__r7HFN","title":"styles_title__Zcv9j","subtitle":"styles_subtitle__OW7YO","callToAction":"styles_callToAction__PRL7J"};